import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GridController, TSortDirections } from '../../classes/grid-page-info';
import {
  DropDownItem,
  FilterItems,
  type ISelect,
} from '../../components/filters/filter.interface';
import {
  IProviderGroupDTO,
  ProviderGroupGridFilters,
} from '../../interfaces/provider/provider-group.interfaces';
import { CommonGraphqlService } from '../common.graphql.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderGroupStateService extends GridController<ProviderGroupGridFilters> {
  public defaultFilter: ProviderGroupGridFilters = {
    groupId: '',
    name: '',
    accountNumber: '',
    accountName: '',
    pMS: '',
    contactName: '',
    addressCity: '',
    addressState: '',
  };

  override _sortDirections: TSortDirections = {
    accountName: '',
    daccountNumber: '',
    groupId: '',
    name: 'ASC',
  };

  filters: FilterItems = {
    filtersName: 'providergroup',
    items: [
      {
        caption: 'Group ID',
        name: 'groupId',
        type: 'text',
        placeholder: 'Enter Group ID',
      },
      {
        caption: 'Group Name',
        name: 'name',
        type: 'text',
        placeholder: 'Enter Group Name',
      },
      {
        caption: 'Account Number',
        name: 'accountNumber',
        type: 'text',
        placeholder: 'Enter Account Number',
      },
      {
        caption: 'Account Name',
        name: 'accountName',
        type: 'text',
        placeholder: 'Enter Account Name',
      },
      {
        caption: 'Contact Name',
        name: 'contactName',
        type: 'text',
        placeholder: 'Enter Contact Name',
      },
      // {
      //   caption: "Phone",
      //   name:"contactPhone",
      //   type:'text',
      //   placeholder: "Enter Phone",
      // },
      // {
      //   caption: "Email",
      //   name:"contactEmail",
      //   type:'text',
      //   placeholder: "Enter Email",
      // },
      // {
      //   caption: "Zip Code",
      //   name:"addressZipcode",
      //   type:'text',
      //   placeholder: "Enter Zip Code",
      // },
      {
        caption: 'City',
        name: 'addressCity',
        type: 'text',
        placeholder: 'Enter City',
      },
      {
        caption: 'State',
        name: 'addressState',
        type: 'states',
        placeholder: 'Select State',
      },
      {
        caption: 'Vendor',
        name: 'pMS',
        type: 'select',
        placeholder: 'Select Vendor',
        asyncValues: undefined,
      },
    ],
  };

  private _groups: IProviderGroupDTO[];

  constructor(private srvCommmon: CommonGraphqlService) {
    super();
    this.init(this.defaultFilter, 1, 'accountNumber', 'ASC');

    const vendorFilter = this.filters.items?.find((f) => {
      return f.name === 'pMS';
    }) as ISelect;
    vendorFilter.asyncValues = this.getApplications();
  }

  get groups(): IProviderGroupDTO[] {
    return this._groups;
  }

  set groups(value: IProviderGroupDTO[]) {
    this._groups = value;
  }

  getApplications(): Observable<DropDownItem[]> {
    return this.srvCommmon.getApplications().pipe(
      map((apps) => {
        return apps.map((a) => {
          return { key: a.code, value: a.description };
        });
      }),
    );
  }
}
